import React, {Component} from 'react';

export default class DecimalHelpBlock extends Component {
    render() {
        return (
            <span className="help-block">
                {window.__js_general.comma_help_text}
            </span>
        );
    }
}